import { blogLandingListWidgetStyles as styles } from "@solveindustrial/Widgets/VerndaleBox/BlogLanding/BlogLandingListWidget";

styles.title = {
    ...styles.title,
    variant: "h1",
};
